export default class EndPlanningModalCtrl {

	constructor ($scope, $mdDialog, WorkPlanModalSrv, WorkPlanSrv, ModalSrv, GlobalConfig, $state, GlobalSrv, $cookies, $sessionStorage) {
		const headData = WorkPlanModalSrv.getVariable()
		const teacherId = headData.teacherId
		const workplanId = headData.workplanId
		const userId = headData.userId
		const stageId = headData.stageId
		const integralEvaluationURL = GlobalConfig.externalURLs.integralEvaluationURL

		let planningFinish = false
		let executionFinish = false
		const currentUser = JSON.parse($cookies.get('currentUser'))

		$scope.data = headData.data
		$scope.totalHours = headData.totalHours
		$scope.totalHoursExecution = headData.totalHoursExecution
		$scope.minHours = headData.minHours
		$scope.maxHours = headData.maxHours
		$scope.isMinHoursPlanning = headData.isMinHoursPlanning
		$scope.isMaxHoursPlanning = headData.isMaxHoursPlanning
		$scope.isMinHoursExecuted = headData.isMinHoursExecuted
		$scope.isMaxHoursExecuted = headData.isMaxHoursExecuted
		$scope.isExistActiWitOutHourExecuted = headData.isExistActiWitOutHourExecuted
		$scope.close = close
		$scope.endPlanning = endPlanning
		$scope.stageId = stageId
		$scope.planning = GlobalConfig.workplanIdStages.planning
		$scope.isPlanning = headData.isPlanning
		$scope.classPlanning = ($scope.isPlanning ? 'col-md-12' : 'col-md-6')
		$scope.stageName = ($scope.isPlanning ? GlobalConfig.workplanStagesNames.planning : GlobalConfig.workplanStagesNames.execution)
		$scope.stageNameText = ($scope.isPlanning ? GlobalConfig.workplanStagesNames.planningText : GlobalConfig.workplanStagesNames.executionText)

		function close () {
			// if ($scope.isPlanning) {
			//   WorkPlanModalSrv.setVariable(planningFinish)
			// } else { WorkPlanModalSrv.setVariable(executionFinish) }
			return $mdDialog.hide()
		}

		function endPlanning (event) {
			let header = {
				workplanId: workplanId,
				teacherId : teacherId,
				stageId   : stageId,
				userId    : userId,
				feedback  : headData.feedback,
			}

			if (! $scope.isPlanning) {
				endExecution(header)
			}

			showModalHoursParametrization(headData, $scope.isPlanning)
		}

		function showModalHoursParametrization (header, isPlanning) {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function($scope, $mdDialog) {
					$scope.data = header
					$scope.integralEvaluationURL = integralEvaluationURL
					$scope.close = function () {
						if (isPlanning) {
							if (header.isMinHoursPlanning || header.isMaxHoursPlanning) {
								close()
							} else {
								confirmPlanning(header)
							}
						} else {
							close()
							$state.reload()
						}
					}
				} ],
				template           : require('../modals/hoursParametrizationModal.html'),
				clickOutsideToClose: false,
			})
		}

		function confirmPlanning (header) {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function confirmPlanning ($scope, $mdDialog) {
					$scope.continue = function () {
						$sessionStorage.workPlanGeneralList.wokplanTeacherStatus[0].planningFinish = 1

						return WorkPlanSrv.endPlanning.post(header).$promise.then((dataReturn) => {
							if (dataReturn.status) {
								planningFinish = true
								getNotify(header.feedback)
								$state.reload()
								close()
							}
						})
					}
					$scope.close = function () {
						close()
						$state.reload()
					}
				} ],
				template           : require('./confirmModal.html'),
				clickOutsideToClose: false,
			})
		}

		function getNotify (feedback) {
			//SE NOTIFICA A REVISORES Y EVALUADORES
			let reviewers = GlobalSrv.getReviewersAndEvaluator()

			reviewers.forEach((reviewer) => {
				getSendNotify(reviewer, feedback)
			})
		}

		function getNotifyFeeback(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, retroalimentacíón finalizada',
				dsDescription               : 'El profesor ' + currentUser.dsFullname + ' ha ajustado su planeación',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}
		}

		function getNotifyMinHours(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, horas minimas planeadas',
				dsDescription               : 'El profesor ' + currentUser.dsFullname + ' finalizó su plan de trabajo con un número menor de horas a las requeridas',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 1,
			}
		}

		function getNotifyMaxHours (idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, horas máximas planeadas',
				dsDescription               : 'El profesor ' + currentUser.dsFullname + ' finalizó la planeación de su plan de trabajo con un número mayor de horas a las requeridas',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 1,
			}
		}

		function getNotifyEndPlanning(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, planeación finalizada',
				dsDescription               : 'El profesor ' + currentUser.dsFullname + ' ha finalizado la planeación',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}
		}

		function getNotifyEndExecution(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, ejecución finalizada',
				dsDescription               : 'El profesor ' + currentUser.dsFullname + ' ha finalizado la ejecución',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}
		}

		function getNotifyHoursExecution(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, limites horas',
				dsDescription               : 'El profesor ' + currentUser.dsFullname + ' finalizo su ejecución con un número de horas ' + headData.totalHoursExecution + ' las cuales son inferiores o superan las horas requeridas.',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 1,
			}
		}

		function getSendNotify(idUser, feedback) {
			if ($scope.isPlanning) {
				if (planningFinish) {
					GlobalSrv.sendNotification(getNotifyEndPlanning(idUser, GlobalConfig.notificationType.email))
					GlobalSrv.sendNotification(getNotifyEndPlanning(idUser, GlobalConfig.notificationType.inbox))
				}

				if (feedback) {
					GlobalSrv.sendNotification(getNotifyFeeback(idUser, GlobalConfig.notificationType.email))
					GlobalSrv.sendNotification(getNotifyFeeback(idUser, GlobalConfig.notificationType.inbox))
				}

				if (headData.minHours > headData.totalHours) {
					GlobalSrv.sendNotification(getNotifyMinHours(idUser, GlobalConfig.notificationType.email))
					GlobalSrv.sendNotification(getNotifyMinHours(idUser, GlobalConfig.notificationType.inbox))
				} else if (headData.totalHours > headData.maxHours) {
					GlobalSrv.sendNotification(getNotifyMaxHours(idUser, GlobalConfig.notificationType.email))
					GlobalSrv.sendNotification(getNotifyMaxHours(idUser, GlobalConfig.notificationType.inbox))
				}
			} else {
				if (headData.minHours > headData.totalHoursExecution || headData.maxHours < headData.totalHoursExecution) {
					GlobalSrv.sendNotification(getNotifyHoursExecution(idUser, GlobalConfig.notificationType.email))
					GlobalSrv.sendNotification(getNotifyHoursExecution(idUser, GlobalConfig.notificationType.inbox))
				}

				if (executionFinish) {
					GlobalSrv.sendNotification(getNotifyEndExecution(idUser, GlobalConfig.notificationType.inbox))
					GlobalSrv.sendNotification(getNotifyEndExecution(idUser, GlobalConfig.notificationType.email))
				}
			}
		}

		function endExecution (header) {
			WorkPlanSrv.endPlanning.post(header).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					executionFinish = true
					GlobalSrv.sendNotification(getNotifyEndExecution(header.userId, GlobalConfig.notificationType.inbox))
					GlobalSrv.sendNotification(getNotifyEndExecution(header.userId, GlobalConfig.notificationType.email))
					getNotify(0)
				}
			})
		}
	}

}

EndPlanningModalCtrl.$inject = [ '$scope', '$mdDialog', 'WorkPlanModalSrv', 'WorkPlanSrv', 'ModalSrv', 'GlobalConfig', '$state', 'GlobalSrv', '$cookies', '$sessionStorage' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/modals/endPlanningModalCtrl.js